import { http } from '../rest';

export function fetchClientDetails(http, demo) {
  return {
    async execute(clientId, timeSpan = '') {
      let data;
      if (demo) {
        const file = await import('./fetchClientDetails.data');
        data = file.default;
      } else {
        const response = await http.get(`/clients/${clientId}/statements${timeSpan}`);
        data = response.data;
      }
      return data;
    },
  };
}

export default fetchClientDetails(http, process.env.DEMO);
